import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import Preloader from "../../components/Preloader";
import NetworkError from "../../components/NetworkError";
import { textes } from "../../constants/textes";
import { config } from "../../constants/config";
import Select from "react-select";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Calendar2, Clock, GiftFill, Map, Person, PhoneFill } from "react-bootstrap-icons";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { MobileDateTimePicker } from "@mui/x-date-pickers";
import moment from "moment";

export default function ForfaitsouscriptionInfos({ codesouscription }) {
    // states
    const { user, logoutUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [editedstate, setEditedstate] = useState(false);
    const [error, setError] = useState(false);

    const [nomclient, setnomclient] = useState("");
    const [telclient, settelclient] = useState("");
    const [libforfait, setlibforfait] = useState("");
    const [libtypeforfait, setlibtypeforfait] = useState("");
    const [profileforfait, setprofileforfait] = useState("");
    const [logincompte, setlogincompte] = useState("");
    const [mdpcompte, setmdpcompte] = useState("");
    const [duree, setduree] = useState("");
    const [datedeb, setdatedeb] = useState(null);
    const [datefin, setdatefin] = useState(null);
    const [codetransaction, setcodetransaction] = useState("");
    const [photoforfait, setphotoforfait] = useState("");
    const [unite, setUnite] = useState("");

    const unites = [
        {
            label: "Années (s)",
            value: "years",
        },
        {
            label: "Mois",
            value: "months",
        },
        {
            label: "Jour (s)",
            value: "days",
        },
    ];

    const [etatdef, setetatdef] = useState("");
    const [datecrea, setDatecrea] = useState("");
    const [etat, setEtat] = useState(0);


    const showErrorMessage = (msg) => {
        toast.error(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    };

    const showSuccesMessage = (msg) => {
        toast.success(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    };

    const getElement = async () => {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.app.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: "GET",
            headers: myHeaders,
            // body: urlencoded,
            redirect: "follow",
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/subscribedbundles/${codesouscription}?page=0`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data?.body?.data);
                    if (data?.head) {
                        let body = data?.body?.data[0];
                        let dureee = body?.duree.split(" ");
                        setduree(body?.duree !== null ? dureee[0] : "");
                        setUnite(body.duree !== null ? {
                            label:
                                dureee[1] === "année(s)"
                                    ? "Année (s)"
                                    : dureee[1] === "mois"
                                        ? "Mois"
                                        : dureee[1] === "jour(s)"
                                            ? "Jour (s)"
                                            : "",
                            value: dureee[1] === "année(s)"
                                ? "years"
                                : dureee[1] === "mois"
                                    ? "months"
                                    : dureee[1] === "jour(s)"
                                        ? "days"
                                        : "",
                        } : "");
                        setnomclient(body?.nomtransaction !== null ? body?.nomtransaction : "");
                        settelclient(body?.numtel !== null ? body?.numtel : "");
                        setlibforfait(body?.lib !== null ? body?.lib : "");
                        setlibtypeforfait(body?.libtforfait !== null ? body?.libtforfait : "");
                        setprofileforfait(body?.pack !== null ? body?.pack : "");
                        setlogincompte(body?.login !== null ? body?.login : "");
                        setmdpcompte(body?.mdp !== null ? body?.mdp : "");
                        setcodetransaction(body?.codetransaction !== null ? body?.codetransaction : "");
                        setphotoforfait(body?.imgforfait !== null ? body?.imgforfait : "/assets/imgs/no-image.png");

                        setdatedeb(body?.datedeb !== null ? moment(new Date(body?.datedeb.slice(0, 16)), "DD/MM/YYYY HH:mm") : null);
                        setdatefin(body?.datefin !== null ? moment(new Date(body?.datefin.slice(0, 16)), "DD/MM/YYYY HH:mm") : null);

                        setetatdef(body?.etatdef !== null ? body?.etatdef : "");
                        setEtat(body?.etat !== null ? body?.etat : 0);

                        // setDatecrea(body?.datecrea !== null ? body?.datecrea.slice(0, 10) : "");
                        setDatecrea(body?.datecrea !== null ? body?.datecrea.slice(0, 16).replace("T", " à ") : "");

                        setLoading(false);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setError(true);
                            setLoading(false);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                setError(true);
                setLoading(false);
            }
        }).catch((err) => {
            // console.log("error", err);
            setError(true);
            setLoading(false);
        });
    };

    // comportements
    useEffect(() => {
        getElement();
    }, []);



    // affichage
    return (
        <div className="row">
            <div className="col-md-12">
                {loading && <Preloader />}
                {!loading && error && <NetworkError />}
                {!loading && !error && (
                    <div
                        className="col-md-12"
                        style={{
                            paddingTop: 8,
                            borderTop: "1px solid #ddd",
                            borderRadius: 8,
                        }}
                    >
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card shadow mb-4">
                                    <div className="card-header py-3">
                                        <button
                                            onClick={() => navigate(-1)}
                                            data-toggle="tooltip"
                                            title={textes.fr.back}
                                            data-placement="left"
                                            className="btn-shadow ml-3 btn btn-dark btn-sm float-right"
                                        >
                                            <i className="fa fa-reply"></i>{" "}
                                            <span>{textes.fr.back}</span>
                                        </button>
                                        <h5 className="m-0 ">
                                            {textes.fr.souscriptioninfoslabel}
                                        </h5>
                                    </div>
                                    <div className="card-body">
                                        <form
                                            style={{ width: "100%" }}
                                            className="mb-3"
                                            onSubmit={() => { }}
                                        >
                                            {/* ={editedstate ? false : true} */}
                                            <div className="row">
                                                <div className="col-md-3 mb-3">
                                                    <div className="row">
                                                        <div className="col-md-12 mb-3">
                                                            <img alt="" src={"/assets/imgs/blank.png"} className={`rounded `} style={{ width: "100%", border: "1px solid" }} />
                                                        </div>
                                                        <div className="col-md-12 mb-3">
                                                            <label htmlFor="nomclient" className="mb-1">CLient</label>
                                                            <div className="input-group flex-nowrap">
                                                                <span className="input-group-text" id="nomclient">
                                                                    <Person />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={nomclient}
                                                                    onChange={(e) =>
                                                                        setnomclient(e.target.value)
                                                                    }
                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12 mb-3">
                                                            <label htmlFor="telclient" className="mb-1">Numéro de téléphone</label>
                                                            <div className="input-group flex-nowrap">
                                                                <span className="input-group-text" id="telclient">
                                                                    <PhoneFill />
                                                                </span>
                                                                <input
                                                                    type="tel"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={telclient}
                                                                    onChange={(e) =>
                                                                        settelclient(e.target.value)
                                                                    }
                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-3 mb-3">
                                                    <div className="row">
                                                        <div className="col-md-12 mb-3">
                                                            <img alt="" src={photoforfait} className={`rounded `} style={{ width: "100%", border: "1px solid" }} />
                                                        </div>
                                                        <div className="col-md-12 mb-3">
                                                            <label htmlFor="libforfait" className="mb-1">Forfait</label>
                                                            <div className="input-group flex-nowrap">
                                                                <span className="input-group-text" id="libforfait">
                                                                    <GiftFill />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={libforfait}
                                                                    onChange={(e) =>
                                                                        setlibforfait(e.target.value)
                                                                    }
                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12 mb-3">
                                                            <label htmlFor="profileforfait" className="mb-1">Profil</label>
                                                            <div className="input-group flex-nowrap">
                                                                <span className="input-group-text" id="profileforfait">
                                                                    <GiftFill />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={profileforfait}
                                                                    onChange={(e) =>
                                                                        setprofileforfait(e.target.value)
                                                                    }
                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 mb-3">
                                                    <div className="row">
                                                        <div className="col-md-12 mb-0">
                                                            <h6 className="m-0">{textes.fr.statelabel} de la souscription</h6>
                                                        </div>
                                                        <div className="col-md-12 mb-3">
                                                            <span
                                                                className={`badge ${etat === 1 ? "badge-success" :
                                                                    etat === 2 ? "badge-warning" :
                                                                        etat === 3 ? "badge-danger" :
                                                                            ""
                                                                    } w-100 mt-2`
                                                                }
                                                                style={{ fontSize: 18, padding: "24px 16px", color: etat === 2 ? "#000" : "#fff" }}>
                                                                {
                                                                    etatdef !== null ? etatdef :
                                                                        "Etat"
                                                                }
                                                            </span>
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="duree" className="mb-1">
                                                                {textes.fr.durelabel} de la souscription
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="duree"
                                                                >
                                                                    <Clock />
                                                                </span>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={duree}
                                                                    onChange={(e) =>
                                                                        setduree(e.target.value)
                                                                    }
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="unite" className="mb-1">
                                                                Unité
                                                            </label>
                                                            <Select
                                                                id="unite"
                                                                name="unite"
                                                                placeholder="Sélectionner l'unité"
                                                                options={unites}
                                                                value={unite}
                                                                onChange={(selected) => {
                                                                    setUnite(selected);
                                                                }}
                                                                isDisabled
                                                            />
                                                        </div>
                                                        <div className="col-md-12 mb-3">
                                                            <MobileDateTimePicker
                                                                label="Date début"
                                                                value={datedeb}
                                                                onChange={(newValue) =>
                                                                    setdatedeb(newValue)
                                                                }
                                                                views={[
                                                                    "year",
                                                                    "day",
                                                                    "hours",
                                                                    "minutes",
                                                                ]}
                                                                className="w-100 mt-2"
                                                                ampm={false}
                                                                disabled={editedstate ? false : true}
                                                            />
                                                        </div>
                                                        <div className="col-md-12 mb-3">
                                                            <MobileDateTimePicker
                                                                label={"Date de fin"}
                                                                value={datefin}
                                                                onChange={(newValue) =>
                                                                    setdatefin(newValue)
                                                                }
                                                                views={[
                                                                    "year",
                                                                    "day",
                                                                    "hours",
                                                                    "minutes",
                                                                ]}
                                                                className="w-100 mt-2"
                                                                ampm={false}
                                                                disabled
                                                            />
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="logincompte" className="mb-1">
                                                                Login compte wifi
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="logincompte"
                                                                >
                                                                    <Person />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={logincompte}
                                                                    onChange={(e) =>
                                                                        setlogincompte(e.target.value)
                                                                    }
                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="mdpcompte" className="mb-1">
                                                                Mot de passe compte wifi
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="mdpcompte"
                                                                >
                                                                    <Map />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={mdpcompte}
                                                                    onChange={(e) =>
                                                                        setmdpcompte(e.target.value)
                                                                    }
                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-md-12 mb-3">
                                                            <label htmlFor="dateadd" className="mb-1">
                                                                Date souscription
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span className="input-group-text" id="dateadd">
                                                                    <Calendar2 />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={datecrea}
                                                                    onChange={(e) => setDatecrea(e.target.value)}
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
